import * as Sentry from '@sentry/react';

export function setupGlobalErrorHandler() {
  // Capturar errores en scripts externos o cualquier error global
  window.onerror = (message, source, lineno, colno, error) => {
    console.error('Error global:', message, source, lineno, colno, error);
    Sentry.captureException(error || new Error(message?.toString()));
  };

  // Capturar promesas rechazadas sin catch
  window.addEventListener('unhandledrejection', (event) => {
    console.error('Promesa rechazada sin catch:', event.reason);
    Sentry.captureException(event.reason);
  });
}
